const patientContextSidebar = {
  demographicsGrid: {
    // U+2014 em-dash placeholder rendered in place of a `null` demographic value
    // (e.g. unknown / not collected). Lives here so translators / product can swap
    // the glyph for a localized fallback word ("Unknown", "N/A") without a code
    // change. The component owns this visible fallback per the FRONTEND.md i18n rule.
    emptyValueFallback: "—",
  },
  labInterpPrimaryCardFooter: {
    // Visible CTA text for the lab-results PDF link. The accompanying download
    // icon is decorative — the accessible name comes from this string.
    viewPdfLabel: "View PDF",
    // Label sits next to the formatted collection date ("Tested on  May 22, 2026").
    testedAtLabel: "Tested on",
    // Label sits next to the practitioner full name ("Ordered by  Dr. Jane Smith").
    orderingPractitionerLabel: "Ordered by",
    // U+2014 em-dash rendered when `testedAt` or `orderingPractitioner` is null.
    // Component-owned per FRONTEND.md so translators can swap the glyph for a
    // localized fallback ("Unknown", "N/A") without a code change.
    emptyValueFallback: "—",
  },
  nthTestCycleIndicator: {
    // English ordinal categories per Intl.PluralRules — pick one based on the
    // ordinal value (1 → "one", 2 → "two", 3 → "few", 4+ → "other"; 21 → "one"
    // for "21st test", etc.). Component picks the variant; the strings stay
    // colocated for translator context. Interpolation variable is `cycle` (not
    // `ordinal`) because react-i18next reserves `ordinal` as a boolean toggle.
    one: "{{cycle}}st test",
    two: "{{cycle}}nd test",
    few: "{{cycle}}rd test",
    other: "{{cycle}}th test",
  },
  patientHeader: {
    patientIdLabel: "ID {{patientId}}",
    viewPatientDetailsLabel: "View patient details for {{name}}",
  },
  priorTestSecondaryCard: {
    // Label sits next to the formatted prior collection date ("Tested on  Apr 1, 2026").
    // Same English copy as labInterpPrimaryCardFooter.testedAtLabel — kept separate so
    // translators can localize "prior test" context independently if a future locale
    // needs to differentiate "prior" from "current" at the label level.
    testedAtLabel: "Tested on",
    // Label sits next to the prior practitioner full name ("Ordered by  Dr. Jane Smith").
    orderingPractitionerLabel: "Ordered by",
    // Visible label for the "View prior interpretation" CTA. Disabled when
    // hasPriorInterpretation is false — but in practice the entire card hides in
    // that case, so the disabled state ships only as a safety affordance.
    viewPriorInterpretationLabel: "View prior interpretation",
    // Visible label for the "View prior wellness plan" CTA. Disabled when
    // hasPriorWellnessPlan is false (e.g. prior cycle had no plan).
    viewPriorPlanLabel: "View prior plan",
    // Visible label for the "Download prior lab results" CTA. Disabled when
    // hasPriorLabResultsPdf is false (e.g. prior result has no PDF on file).
    downloadPriorPdfLabel: "Download prior lab results",
    // U+2014 em-dash rendered when `priorTestedAt` or `priorPractitioner` is null.
    // Component-owned per FRONTEND.md so translators can swap the glyph for a
    // localized fallback ("Unknown", "N/A") without a code change.
    emptyValueFallback: "—",
  },
} as const;

export { patientContextSidebar };
